export default __webpack_public_path__ + "static/media/(13).e5777c2e.jpg";